/**
 * A function that does nothing.
 * Useful as a default argument or prop.
 */
export function noopFunction() {
    return undefined;
}
/**
 * A function that is empty
 * Useful as a default argument or prop.
 */
export var emptyFunction = function () {
    /* no op */
};
